import React from 'react';
import { LayoutDashboardIcon, PackageIcon, UsersIcon, BarChartIcon, SettingsIcon, SearchIcon } from 'lucide-react';
interface SidebarProps {
  activeItem: string;
}
export const Sidebar: React.FC<SidebarProps> = ({
  activeItem
}) => {
  const menuItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: <LayoutDashboardIcon size={20} data-id="element-93" />
  }, {
    id: 'services',
    label: 'Services',
    icon: <PackageIcon size={20} data-id="element-94" />
  }, {
    id: 'user-management',
    label: 'User Management',
    icon: <UsersIcon size={20} data-id="element-95" />
  }, {
    id: 'performance',
    label: 'Performance',
    icon: <BarChartIcon size={20} data-id="element-96" />
  }, {
    id: 'admin-settings',
    label: 'Administrative Settings',
    icon: <SettingsIcon size={20} data-id="element-97" />
  }];
  return <div className="w-56 bg-white border-r border-gray-200 flex flex-col h-screen" data-id="element-98">
      <div className="p-4" data-id="element-99">
        <div className="flex items-center space-x-2" data-id="element-100">
          <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center" data-id="element-101">
            <span className="text-white font-bold" data-id="element-102">1</span>
          </div>
          <span className="text-blue-500 font-bold text-xl" data-id="element-103">nestop</span>
        </div>
      </div>
      <div className="px-4 py-2" data-id="element-104">
        <div className="relative" data-id="element-105">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-106">
            <SearchIcon size={16} className="text-gray-400" data-id="element-107" />
          </div>
          <input type="text" placeholder="Search" className="pl-10 pr-4 py-2 w-full bg-gray-100 rounded-md text-sm focus:outline-none" data-id="element-108" />
        </div>
      </div>
      <nav className="mt-4 flex-1" data-id="element-109">
        <ul data-id="element-110">
          {menuItems.map(item => <li key={item.id} data-id="element-111">
              <a href="#" className={`flex items-center px-4 py-3 text-sm ${activeItem === item.id ? 'bg-blue-50 text-blue-500 border-l-4 border-blue-500' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-112">
                <span className="mr-3" data-id="element-113">{item.icon}</span>
                <span data-id="element-114">{item.label}</span>
              </a>
            </li>)}
        </ul>
      </nav>
      <div className="p-4 border-t border-gray-200" data-id="element-115">
        <div className="flex items-center" data-id="element-116">
          <div className="w-8 h-8 rounded-full bg-gray-300 mr-2" data-id="element-117">
            <img src="https://i.pravatar.cc/32" alt="User" className="w-full h-full rounded-full" data-id="element-118" />
          </div>
          <div className="flex-1" data-id="element-119">
            <p className="text-sm font-medium" data-id="element-120">Alli Abubakar</p>
            <p className="text-xs text-gray-500" data-id="element-121">alli@pfms.net</p>
          </div>
          <button className="text-gray-400" data-id="element-122">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-123">
              <circle cx="12" cy="12" r="1" data-id="element-124"></circle>
              <circle cx="19" cy="12" r="1" data-id="element-125"></circle>
              <circle cx="5" cy="12" r="1" data-id="element-126"></circle>
            </svg>
          </button>
        </div>
      </div>
    </div>;
};